import { Box, Container, Typography, Paper, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SearchOff } from "@mui/icons-material";

const NotFoundPage = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: "100%", textAlign: "center" }}>
          <SearchOff color="primary" sx={{ fontSize: 60, mb: 2 }} />

          <Typography variant="h4" component="h1" gutterBottom>
            Page Not Found
          </Typography>

          <Typography variant="body1" sx={{ mb: 4 }}>
            Sorry, the page you're looking for doesn't exist. It may have been
            moved or deleted. Please check the URL or navigate back to the
            dashboard.
          </Typography>

          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
          >
            Go to Dashboard
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
